<div class="becks-quick-family-filter">
  @for (family of familyGroups; track family) {
    <button
      [class.selected]="family.code === selectedFamilyGroup.code"
      (click)="handleFamilyGroupSelected(family)"
      mat-raised-button
      class="becks-quick-family-filter__button"
    >
      {{ family.desc | titlecase }}
    </button>
  }
</div>
